
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { singleton, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";

export const initialState = new State(new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, getCustomerConfiguration((Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
}

export function update(onConfigurationChanged, msg, state) {
    let matchResult, response_4;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            response_4 = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 2;
            response_4 = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 3;
            break;
        }
        case 5: {
            matchResult = 4;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            const file = msg.fields[1];
            if (state.AppLogoConfiguration.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const formData = new FormData();
                formData.append(file.name, file);
                return [new State(state.AppLogoConfiguration, FormState__startLoading(state.FormState)), (msg.fields[0].tag === 1) ? Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(tupledArg_1[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), undefined, (response_1) => {
                        const pr_1 = response_1.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                    }, refreshOn_1)))(true);
                })), ["/api/customer/logo/square", formData], (Item_2) => (new Msg(2, [Item_2])), (Item_3) => (new Msg(5, [Item_3]))) : Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), ["/api/customer/logo/wide", formData], (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 1:
            if (state.AppLogoConfiguration.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.AppLogoConfiguration, FormState__startLoading(state.FormState)), (msg.fields[0].tag === 1) ? Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_11;
                    return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response_3) => {
                        const pr_3 = response_3.arrayBuffer();
                        return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), string_type));
                    }, refreshOn_3)))(true);
                })), "/api/customer/logo/square", (Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(5, [Item_7]))) : Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_8;
                    return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response_2) => {
                        const pr_2 = response_2.arrayBuffer();
                        return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                    }, refreshOn_2)))(true);
                })), "/api/customer/logo/wide", (Item_4) => (new Msg(3, [Item_4])), (Item_5) => (new Msg(5, [Item_5])))];
            }
        case 2:
            if (response_4.tag === 1) {
                return [new State(state.AppLogoConfiguration, FormState__setValidationResponse_5219762A(state.FormState, response_4.fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.AppLogoConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), getCustomerConfiguration((Item_8) => (new Msg(4, [Item_8])), (Item_9) => (new Msg(5, [Item_9]))), Cmd_ofEffect((_arg) => {
                    onConfigurationChanged();
                })]))];
            }
        case 3:
            return [new State(new RequestedValue$1(1, [msg.fields[0].AppLogoConfiguration]), state.FormState), Cmd_none()];
        default:
            return [new State(state.AppLogoConfiguration, FormState_get_empty()), Cmd_none()];
    }
}

